import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'option-particulier',
    templateUrl: './option-particulier.component.html',
    styleUrls: ['./option-particulier.component.scss'],
    standalone: false
})
export class OptionParticulierComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: 'var(--info-alert-bg-color)',
    iconColor: 'var(--info-alert-font-color)',
    textColor: 'var(--info-alert-font-color)',
  };
  options: FormControlOption[] = [
    {
      label: 'Bien supplémentaire',
      value: '300€ TTC',
      displayValue: '€ TTC',
      hardFormControlName: 'additionalPropertyTotal',

      suffix: 'A',
      formControlName: 'additionalPropertyOption',
      input: {
        formControlName: 'additionalPropertyNumber',
      },
    },
    {
      label: 'Affiliation TNS',
      value: 'tnsAffiliation',
      displayValue: '216€ TTC',
      suffix: 'C',
      formControlName: 'tnsAffiliationOption',

      description: 'Pour les locations meublées professionnelles.',
    },
  ];
  isConsultant: boolean = false;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    if (!this.isConsultant) {
      this.options = this.options.filter(
        option =>
          option.value != 'Simulation sur mesures' &&
          option.value != 'tnsAffiliation',
      );
    }
    this.subscriptionFacade.initForm(this);
    this.subscribeToProductValueChanges();
    this.subscribeToAdditionalPropertyNumberChanges();
  }
  private subscribeToAdditionalPropertyNumberChanges() {
    const product = this.products?.get('0');
    if (!product) return;
    product
      ?.get('parameters')
      ?.get('additionalPropertyNumber')
      ?.valueChanges.subscribe(value => {
        product
          ?.get('parameters')
          ?.get('additionalPropertyTotal')
          ?.setValue(value * 60);
      });
  }

  private subscribeToProductValueChanges() {
    const product = this.products?.get('0');
    if (!product) return;

    product.valueChanges.subscribe(({ parameters }) => {
      const { additionalPropertyOption, additionalPropertyNumber } =
        parameters || {};
      if (additionalPropertyOption && !additionalPropertyNumber) {
        product
          ?.get('parameters')
          ?.get('additionalPropertyNumber')
          ?.setValue(1);
        this.products
          .get('0')
          ?.get('parameters')
          .get('additionalPropertyTotal')
          ?.setValue(additionalPropertyNumber);
        product
          ?.get('parameters')
          ?.get('additionalPropertyTotal')
          ?.setValue(60);
      } else if (!additionalPropertyOption && additionalPropertyNumber) {
        product
          ?.get('parameters')
          ?.get('additionalPropertyNumber')
          ?.setValue(0);
      }
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  select(option: FormControlOption) {
    const checked = this.products
      .get('0')
      .get('parameters')
      .get(option.formControlName)?.value;

    if (!checked) {
      this.products
        .get('0')
        .get('parameters')
        .get(option.formControlName)
        ?.setValue(true);
    }
  }
}
